import React, {
  ChangeEvent,
  MouseEvent,
  useEffect,
  useRef,
  useState,
} from "react"
import { SearchSvg, CloseSvg } from "~/ui-rtk/components/ui/svg/essentials"
import { cn } from "~/ui-rtk/utils/tailwind-utils"
import { useClickOutside } from "~/ui-rtk/shared/hooks"

type TSearchBarProps = {
  onSearch?: (searchTerm: string) => void
}

const SearchBar: React.FC<TSearchBarProps> = ({ onSearch }) => {
  const [searchTerm, setSearchTerm] = useState("")
  const [isSearchFocus, setIsSearchFocus] = useState(false)
  const inputContainerRef = useRef<HTMLDivElement>(null)
  const inputRef = useRef<HTMLInputElement>(null)
  void useClickOutside(inputContainerRef, () => setIsSearchFocus(false))

  const handleFocus = (event: MouseEvent) => {
    void event.stopPropagation()
    void event.preventDefault()

    void setIsSearchFocus(prev => !prev)
  }

  const handleSearch = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    void setSearchTerm(value)
    void onSearch?.(value)
  }

  const clearSearch = () => {
    setSearchTerm("")
    onSearch?.("")
    setIsSearchFocus(false)
  }

  useEffect(() => {
    if (isSearchFocus) {
      void inputRef.current?.focus()
    }
  }, [isSearchFocus])

  return (
    <div className="flex justify-end">
      <div
        ref={inputContainerRef}
        className={cn(
          "h-12 flex justify-center items-center transition-[width] relative cursor-pointer px-4 rounded-2xl border border-basic-blue bg-basic-dark-blue",
          isSearchFocus ? "w-80" : "w-12",
        )}
      >
        <input
          ref={inputRef}
          value={searchTerm}
          onChange={handleSearch}
          placeholder="Search sources..."
          className={cn(
            "hidden min-h-0 bg-transparent ring-0 active:ring-0 focus:ring-0 text-white border-basic-blue bg-basic-dark-blue placeholder-gray-300",
            isSearchFocus && "w-full visible block",
          )}
        />
        <div
          className="flex items-center justify-center absolute h-full w-11 self-end right-0"
          onClick={isSearchFocus && searchTerm ? clearSearch : handleFocus}
        >
          {!isSearchFocus && <SearchSvg />}
          {isSearchFocus && !searchTerm && <SearchSvg />}
          {isSearchFocus && searchTerm && <CloseSvg />}
        </div>
      </div>
    </div>
  )
}

export default SearchBar
